import React from 'react';
import { Button } from '@naf-simba/elements-buttons';
import { useDocumentUrlWithNode } from '@hooks/Documents/useDocumentUrl';
import { addUrlParam } from '@lib/addUrlParams';
import CtaActivateButton from './CtaActivateButton';
import CtaButtonWithDiscountInfo from './CtaButtonWithDiscountInfo';
import { ExternalActivationHiddenForm } from '../../MyMembership/ProductFlyout/utils/ExternalActivationHiddenForm';
import { CtaButtonProps, CTAProps } from './BenefitCallToActions.types';
import * as S from './BenefitCallToActions.styles';

const CtaButton = ({
  callToAction,
  urlParameters,
  onClickBecomeAMember,
  handleCtaBlankExternalTracking,
  accessDetails,
}: CtaButtonProps) => {
  const ctaInternalUrl = useDocumentUrlWithNode(callToAction?.ctaInternalLink?.referenceComponent);

  const callToActionUrl =
    callToAction?.url && Object.keys(urlParameters).length > 0
      ? addUrlParam(urlParameters, callToAction.url)
      : callToAction?.url || null;

  const showBecomeMemberButton =
    accessDetails &&
    (accessDetails.membershipRole === 'Member' || !accessDetails.membershipRole) &&
    !accessDetails.isAccessibleForUser;

  if (
    !callToActionUrl &&
    callToAction?.type !== 'InternalLink' &&
    callToAction?.type !== 'InternalEndpointActivate' &&
    !showBecomeMemberButton
  )
    return null;

  const ctaRenderSwitch = (callToActionType: CTAProps['type']) => {
    switch (callToActionType) {
      case 'ExternalEndpointActivate':
        return (
          <ExternalActivationHiddenForm
            externalActivationDetails={callToAction.externalTransaction}
            buttonText={callToAction.buttonText}
            shouldHaveActivationButton
          />
        );
      case 'InternalLink':
        return (
          <Button color="primary" to={ctaInternalUrl}>
            {callToAction.buttonText}
          </Button>
        );
      case 'InternalEndpointActivate':
        // show button that calls the api, no link involved
        return <CtaActivateButton callToAction={callToAction} />;
      default:
        // show button that handles linking
        return (
          <Button
            onClick={handleCtaBlankExternalTracking(callToAction)}
            href={callToActionUrl}
            target={callToAction.blank ? '_blank' : '_self'}
            disabled={callToAction.disabled}
          >
            {callToAction.buttonText}
          </Button>
        );
    }
  };

  return !showBecomeMemberButton ? (
    <S.CTAWrapper>{callToAction && ctaRenderSwitch(callToAction.type)}</S.CTAWrapper>
  ) : (
    <CtaButtonWithDiscountInfo onClickBecomeAMember={onClickBecomeAMember} />
  );
};

export default CtaButton;
